export default __webpack_public_path__ + "static/media/Penny Bun18.76f87fe6.jpg";